registerComponent("pages/digital", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * As duas listas de cartões (`.box-list` em `.wrap-cards`, `.box-list-2` em
 * `.wrap-cards-2`) eram slick montado e desmontado por `$window.on('resize')`:
 * abaixo de 768 `.slick(…)`, de 768 para cima `.slick('unslick')`. Agora o
 * degrau é um só e mora no LESS — `scroll-snap-type: x mandatory` dentro do
 * `@legacy-maxSm`, `none` fora —, e o `Asa.trilho` se desativa sozinho quando
 * lê `none`. Nenhum `matchMedia` aqui: o CSS é a única fonte do degrau, e é
 * por isso que o trilho não repete o descompasso 767/768 do legado.
 *
 * ⚠️ Em 768 px exatos o legado tinha slick (`wW < 768` é falso, mas o
 * `@maxSm` de 2020 é `max-width: 767px`, então o CSS já era o de desktop) —
 * nunca coincidiram. Agora coincidem. Nenhum screenshot do baseline está em
 * 768; a diferença é aceita e está declarada no relatório do sub-lote 6a.
 */

/**
 * Liga um trilho por lista, com as setas e os pontos do
 * `blocks/slider-controls` que vive no mesmo pai — era o
 * `$elm.parents('.wrap-cards').find('.slick-prev' | '.slick-next' | '.slider-dots')`
 * que o slick recebia em `prevArrow`/`nextArrow`/`appendDots`.
 *
 * @param {string} seletorDoPai
 * @param {string} seletorDaLista
 * @returns {void}
 */
function ligarTrilhos(seletorDoPai, seletorDaLista) {
    component.querySelectorAll(seletorDoPai).forEach(function (pai) {
        const lista = pai.querySelector(seletorDaLista);

        // O `totalItens > 1` de 2020. O trilho também se recusa com um item
        // só, mas o guarda aqui evita montar pontos para nada.
        if (!lista || lista.querySelectorAll('.box').length < 2) {
            return;
        }

        Asa.trilho(lista, Object.assign(
            { itens: '.box', passo: 'item' },
            Asa.controlesDoTrilho(pai),
        ));
    });
}

ligarTrilhos('.wrap-cards', '.box-list');
ligarTrilhos('.wrap-cards-2', '.box-list-2');

});
